/**
 * Nav toggle events
 *
 * On click rotates hamburger icon and opens mobile nav-toggle
 * Used for small screens
 */

$('#nav-toggle').on('click', function() {
 $('#nav-toggle').toggleClass('nav-toggle--opened');
 $('#mobile-nav').toggleClass('mobile-nav--opened');
});
